/*
 *   File : goal-based.js
 *   Author : https://evoqins.com
 *   Description : Goal based tab data component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// custom components
import { BasketCard } from '../../../Components/Card';

const GoalBased = (props) => {

    const { state } = useLocation();

    const [selectedYear, setSelectedYear] = useState(0);


    useEffect(() => {
        if (state !== null) {
            setSelectedYear(state.selected_year);
        } else {
            setSelectedYear(1);
        }
    }, [state]);

    // handle tab select year
    // const _handleSelectYear = (tab_id) => {
    //     navigate("/baskets", {
    //         state: {
    //             tab_index: 1,
    //             selected_year: tab_id,
    //         }
    //     });
    // };

    return (

        <div className='row row-gap-3 pt-4'>
            {props.basketData.map((data, key) => (
                <div key={key} className='col-6'>
                    <BasketCard basketData={data}
                        selectedTab={props.selectedTab}
                        handleRebalance={() => props.handleRebalance(data)}
                        duration={props.duration} />
                </div>
            ))}
        </div>
    )
}

export default GoalBased;
